import { DefaultButton, PrimaryButton, Stack, TextField, Text, Dropdown, SelectableOptionMenuItemType, Spinner, Label, TooltipHost, ComboBox, Toggle, Checkbox } from 'office-ui-fabric-react';
import { FontIcon, ITooltipProps } from '@fluentui/react/lib/Icon';
import React, { Component } from 'react';
import { Query } from 'react-apollo';
import { MyContext } from '../../../../context';
import * as QueryAI from '../../AIQuestion/AIQuestionQuery';
import * as QueryAIAssistant from '../ContentUnderstandingQuery';
import { getAllCustomFieldDefinitions } from "../../../../queries/querySettings";





export default class EditContentUnderstanding extends Component {
    static contextType = MyContext

    tooltipProps: ITooltipProps = {
        onRenderContent: () => (
            <div>
                <div>
                    {this.context.getTranslation("compliance", "questionTooltipTitle")}
                </div>
                <div>
                    {this.context.getTranslation("compliance", "questionTooltipSubtitle")}
                </div>
                <ol>
                    <li>{this.context.getTranslation("compliance", "AIquestionTooltipRow1")}</li>
                    <li>{this.context.getTranslation("compliance", "AIquestionTooltipRow2")}</li>
                    <li>{this.context.getTranslation("compliance", "AIquestionTooltipRow3")}</li>
                    <li>{this.context.getTranslation("compliance", "AIquestionTooltipRow4")}</li>
                </ol>
            </div>
        ),
    };

    tooltipPropsAutomatedOnDemand: ITooltipProps = {
        onRenderContent: () => (
            <div>
                <div>
                    {this.context.getTranslation("compliance", "automatedOnDemandTooltip")}
                </div>
            </div>
        ),
    };

    wrapWithInfoTooltip = function(rs, align, subrender){
        return <div style={{ display: 'flex', flexDirection: 'row', alignItems: align ?? 'anchor-center' }}>
                {subrender}
                <TooltipHost content={this.context.getTranslation("compliance", rs)}>
                    <FontIcon aria-label="Compass" iconName="Info" style={{ color: this.props.theme.palette.black, marginTop: '5px', marginLeft: '5px', cursor: 'pointer' }} />
                </TooltipHost>
            </div>
    }

    textLabelWithTooltip = function (rs, align) {
        return (props, defaultRender) => {
            return this.wrapWithInfoTooltip(rs,align,<span>{defaultRender(props)}</span>)
        }
    }

    constructor(props) {
        super(props);
        const aiQuestion = this.props.data !== undefined ? this.props.data : null
        this.state = {
            //page data
            processing: false,
            //phrase data
            id: aiQuestion !== null ? aiQuestion.id : null,
            name: aiQuestion !== null ? aiQuestion.name : "",
            description: aiQuestion !== null ? aiQuestion.description : "",
            question: aiQuestion !== null ? aiQuestion.question : "",
            tenantId: aiQuestion !== null ? aiQuestion.tenantId : null,
            version: aiQuestion !== null ? aiQuestion.version : 0,
            aiQuestionGroup: aiQuestion !== null ? aiQuestion.aiQuestionGroup.id : null,
            generalGroup: aiQuestion !== null ? aiQuestion.aiQuestionGroup.generalGroup : false,
            masterItemId: aiQuestion !== null ? aiQuestion.masterItemId : null,
            selected: aiQuestion !== null ? aiQuestion.selected : true,
            matchAbsence: aiQuestion !== null ? aiQuestion.matchAbsence : false,
            //versions
            selectedOtherVersion: false,
            selectedVersion: aiQuestion !== null ? aiQuestion.id : null,
            //AIAssistant fields
            aIQuestionType: aiQuestion !== null ? aiQuestion.aIQuestionType : "CUQuestion",
            active: aiQuestion !== null ? aiQuestion.active : false,
            logInteraction: aiQuestion !== null ? aiQuestion.logInteraction : false,
            automated: aiQuestion !== null ? aiQuestion.automated : false,
            saveResult: aiQuestion !== null ? aiQuestion.saveResult : false,
            customField: aiQuestion !== null ? aiQuestion.customField : "",
            mergeResults: aiQuestion !== null ? aiQuestion.mergeResults : false,
        };
    }


    changeAIAssistantField = (e, value) => {
        if (e.target.id == "automated" && value) {
            this.setState({
                [e.target.id]: value,
                selectedOtherVersion: false,
                saveResult: true
            })
        } else if (e.target.id == "automated" && !value) {
            this.setState({
                [e.target.id]: value,
                selectedOtherVersion: false,
                saveResult: false
            })
        }
        this.setState({
            [e.target.id]: value,
            selectedOtherVersion: false
        })
    }

    componentDidMount() {
        this.refreshVersions()
    }

    refetchQueryVersions = null;
    numberOfVersions = 1

    refreshVersions = () => {
        if (this.refetchQueryVersions !== null) {
            this.refetchQueryVersions()
        }
    }

    changeText = (e, value) => {
        this.setState({
            [e.target.id]: value,
            selectedOtherVersion: false
        })
    }

    changeMatchAbsence = (e, value) => {
        this.setState({
            matchAbsence: value,
            selectedOtherVersion: false
        })
    }

    isValid = () => {
        return this.state.name !== "" && this.state.question !== "";
    }

    cancel = () => {
        this.props.closePanel()
    }

    save = (saveAsTemplate, saveAsNew) => {
        this.setState({ processing: true })
        const auth = this.props.auth
        const aiQuestion = {
            id: saveAsNew ? null : this.state.id,
            name: this.state.name,
            description: this.state.description,
            question: this.state.question,
            tenantId: this.state.tenantId,
            // manage version
            version: saveAsNew ? 1 : this.numberOfVersions,
            aiQuestionGroup: { id: this.state.aiQuestionGroup, generalGroup: this.state.generalGroup },
            masterItemId: saveAsNew ? null : this.state.masterItemId,
            selected: this.state.selected,
            matchAbsence: this.state.matchAbsence,
            //manage field of AIAssistant
            aIQuestionType: this.state.aIQuestionType,
            active: this.state.active,
            logInteraction: this.state.logInteraction,
            automated: this.state.automated,
            saveResult: this.state.saveResult,
            customField: this.state.customField,
            mergeResults: this.state.mergeResults
        }
        this.props.apol
            .mutate({
                mutation: saveAsTemplate ? QueryAI.createAIQuestionAsTemplate : QueryAI.createAIQuestion,
                variables: { auth, aiQuestion }
            })
            .then((result) => {
                var resultData = saveAsTemplate ? result.data.upsertAIQuestionAsTemplate : result.data.upsertAIQuestion
                var state = {}
                if (resultData.status === "ok") {
                    this.props.closePanel()
                    console.log(this.props.refreshAIAssistant())
                    this.props.refreshAIAssistant()
                } else {
                    this.props.setMessageError(this.context.getTranslation("compliance", resultData.text))
                }
                this.setState({ ...state, processing: false })
            });
    }

    onChangeVersion = (e, item) => {
        //get specific version to fill the fields
        this.setState({ processing: true })
        let id = item.key
        let auth = this.props.auth
        this.props.apol
            .query({
                query: QueryAIAssistant.queryGetContentUnderstandingQuestion,
                variables: { auth, id }
            })
            .then(({ loading, error, data, refetch }) => {
                let oldVersion = data.getAIQuestion;
                this.setState({
                    name: oldVersion.name,
                    description: oldVersion.description,
                    question: oldVersion.question,
                    tenantId: oldVersion.tenantId,
                    selectedVersion: id,
                    selectedOtherVersion: true,
                    processing: false,
                    active: oldVersion.active,
                    logInteraction: oldVersion.logInteraction,
                    automated: oldVersion.automated,
                    saveResult: oldVersion.saveResult,
                    customField: oldVersion.customField,
                    mergeResults: oldVersion.mergeResults
                })
            });
    }

    getCount = (option) => {
        let count = "";
        this.state.accesibleCustomFields.map((name, i) => {

            if (option.key == name || option.text == name) {
                count = i + 1;
            }
        });
        return count;
    }

    restoreVersion = () => {
        this.setState({ processing: true })
        //restoreAdherencePhrase -> id vesrion to restore
        let id = this.state.selectedVersion
        this.props.apol
            .mutate({
                mutation: QueryAI.restoreAIQuestion,
                variables: { id }
            })
            .then((result) => {
                if (result.data.restoreAIQuestion.status === "ok") {
                    this.props.closePanel()
                    this.props.refreshAIAssistant()
                } else {
                    this.props.setMessageError(this.context.getTranslation("compliance", result.data.restoreAIQuestion.text))
                }
                this.setState({
                    selectedOtherVersion: false,
                    processing: false
                })
            });
    }


    render() {
        let masterItemId = this.state.masterItemId
        var saveAsTemplateStyle = { marginTop: "30px", marginLeft: "15px" }
        return (
            <div>
                {/*QUERY ALL VERSIONS*/}
                <Query
                    query={QueryAI.getAllVersionOfAIQuestion}
                    variables={{ masterItemId }}>
                    {({ loading, error, data, refetch }) => {
                        this.refetchQueryVersions = refetch
                        if (loading) {
                            return (<Spinner label={this.context.getTranslation("common", "loading")} ariaLive="assertive" labelPosition="top" />)
                        }
                        if (error) {
                            return ""
                        }
                        if (data.getAllVersionOfAIQuestion == null) {
                            return ""
                        }
                        let versions = data.getAllVersionOfAIQuestion.map(v => {
                            return {
                                "key": v.id,
                                "text": v.version
                            }
                        })
                        this.numberOfVersions = versions.length
                        return (<div>
                            {versions.length > 0 && <Stack >
                                <Stack.Item>
                                    <Dropdown
                                        label={this.context.getTranslation("compliance", "version")}
                                        selectedKey={this.state.selectedVersion}
                                        onChange={this.onChangeVersion}
                                        options={versions}
                                    />
                                </Stack.Item>
                            </Stack>}
                        </div>
                        )
                    }}
                </Query>
                <TextField onRenderLabel={this.textLabelWithTooltip('cuFieldNameTooltip')} label={this.context.getTranslation("compliance", "cuFieldName")} id="name" value={this.state.name} onChange={this.changeText} required />
                <TextField label={this.context.getTranslation("compliance", "description")} id="description" value={this.state.description} onChange={this.changeText} />
                <Stack>
                    <Stack horizontal>
                        <Label required> {this.context.getTranslation("compliance", "field")}</Label>
                        <TooltipHost tooltipProps={this.tooltipProps}>
                            <FontIcon aria-label="Compass" iconName="Info" style={{ color: this.props.theme.palette.black, marginTop: '5px', marginLeft: '5px', cursor: 'pointer' }} />
                        </TooltipHost>
                    </Stack>
                    <TextField id="question" value={this.state.question} onChange={this.changeText} />
                </Stack>
                <Stack style={{ paddingTop: "1em" }}>
                    <Checkbox id="mergeResults" checked={this.state.mergeResults}
                        onChange={(e, v) => this.setState({ 'mergeResults': v, selectedOtherVersion: false })}
                        label={this.context.getTranslation("compliance", "cuQuestionMergeResults")}></Checkbox>
                </Stack>
                <Stack >
                    {this.wrapWithInfoTooltip("cuCustomFieldNameTooltip",undefined,<Label> {this.context.getTranslation("compliance", "customField")}</Label>)}
                    <Query
                        query={getAllCustomFieldDefinitions}
                        variables={this.props.authorization}>

                        {({ loading, error, data }) => {
                            if (loading) return <>
                                <Spinner label={this.context.getTranslation("common", "loadingData")} ariaLive="assertive" labelPosition="top" />
                            </>;
                            if (error) return <h1> </h1>;

                            if (data.getAllCustomFieldDefinitions == null) {
                                return <div> </div>;

                            }

                            var customFieldsOptions = [];
                            customFieldsOptions.push({ key: "Header1", text: "Custom Fields", itemType: SelectableOptionMenuItemType.Header });

                            for (var i = 0; i < data.getAllCustomFieldDefinitions.length; i++) {
                                customFieldsOptions.push({
                                    key: data.getAllCustomFieldDefinitions[i].id, text: data.getAllCustomFieldDefinitions[i].fieldName
                                })
                            }

                            return <span>
                                <ComboBox
                                    id="selectFields"
                                    style={{ width: "300px" }}
                                    selectedKey={this.state.customField}
                                    allowFreeform={false}
                                    autoComplete={true}
                                    onChange={(e, option) => {
                                        this.setState({
                                            customField: option ? option.key : "",
                                            selectedOtherVersion: false
                                        })
                                    }}
                                    options={customFieldsOptions}
                                    placeholder="Optional select custom field"
                                />
                            </span>
                        }
                        }
                    </Query>

                </Stack>

                {/*FOOTER BUTTONS*/}
                <Stack horizontal style={{ flexFlow: "row-reverse" }}>
                    <DefaultButton text={this.context.getTranslation("common", "cancel")} onClick={this.cancel} style={{ marginTop: "30px", marginLeft: "15px" }} disabled={this.state.processing} />
                    {(!this.state.selectedOtherVersion || this.state.id === this.state.selectedVersion) &&
                        <PrimaryButton text={this.context.getTranslation("common", "save")} onClick={() => this.save(false,false)} style={{ marginTop: "30px", marginLeft: "15px" }} disabled={!this.isValid() || this.state.processing} />
                    }
				{(!this.state.selectedOtherVersion || this.state.id === this.state.selectedVersion) &&
                        <PrimaryButton text={this.context.getTranslation("compliance", "saveAsNew")} onClick={() => this.save(false,true)} style={{ marginTop: "30px", marginLeft: "15px" }} disabled={!this.isValid() || this.state.processing} />
                    }
                    {(this.props.userRules.userTemplateAllowed && (!this.state.selectedOtherVersion || this.state.id === this.state.selectedVersion)) &&
                        <PrimaryButton text={this.context.getTranslation("common", "saveAsTemplate")} onClick={() => this.save(true,false)} style={!this.isValid() || this.state.processing ? saveAsTemplateStyle : { ...saveAsTemplateStyle, background: "red", color: "white" }} allowDisabledFocus={true} disabled={!this.isValid() || this.state.processing} />
                    }
                    {this.state.selectedOtherVersion && this.state.id !== this.state.selectedVersion &&
                        <PrimaryButton text={this.context.getTranslation("compliance", "restoreVersion")} onClick={this.restoreVersion} style={{ marginTop: "30px", marginLeft: "15px" }} disabled={!this.isValid() || this.state.processing} />
                    }
                </Stack>
            </div>
        );
    }
}